import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { StatusCount } from '@models/overviewData';
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { JobDashboardConfiguration, JobDashboardRange } from './job-dashboard-configuration';

dayjs.extend(quarterOfYear);

@Injectable({
  providedIn: 'root',
})
export class JobDashboardService {
  constructor(protected http: HttpClient) {}

  getData(config: JobDashboardConfiguration): Observable<StatusCount[]> {
    let from = config.from;
    let to = config.to;
    if (config.range !== JobDashboardRange.CUSTOM) {
      from = this.getFromForRange(config.range);
      to = this.getToForRange(config.range);
    }
    return this.http.post<StatusCount[]>(`${environment.apiUrls.workflow}/api/v1/dashboard/jobs/status-count`, {
      dataConnectionIds: config.dataConnectionIds,
      from,
      to,
    });
  }

  getFromForRange(range: JobDashboardRange): dayjs.Dayjs {
    const now = dayjs().startOf('day');

    switch (range) {
      case JobDashboardRange.TODAY:
        return now.startOf('day');
      case JobDashboardRange.THIS_WEEK:
        return now.startOf('week');
      case JobDashboardRange.THIS_MONTH:
        return now.startOf('month');
      case JobDashboardRange.THIS_QUARTER:
        return now.startOf('quarter');
      case JobDashboardRange.THIS_YEAR:
        return now.startOf('year');
      case JobDashboardRange.LAST_24_HOURS:
        return now.subtract(24, 'hour');
      case JobDashboardRange.LAST_7_DAYS:
        return now.subtract(7, 'day');
      case JobDashboardRange.LAST_30_DAYS:
        return now.subtract(30, 'day');
      case JobDashboardRange.LAST_90_DAYS:
        return now.subtract(90, 'day');
      case JobDashboardRange.LAST_365_DAYS:
        return now.subtract(365, 'day');
      case JobDashboardRange.ALL_TIME:
        return dayjs('1970-01-01'); // or any earliest date you consider
      case JobDashboardRange.CUSTOM:
        throw new Error('Custom range requires manual input');
      default:
        return now;
    }
  }

  getToForRange(range: JobDashboardRange): dayjs.Dayjs {
    const now = dayjs().endOf('day');

    switch (range) {
      case JobDashboardRange.TODAY:
      case JobDashboardRange.THIS_WEEK:
      case JobDashboardRange.THIS_MONTH:
      case JobDashboardRange.THIS_QUARTER:
      case JobDashboardRange.THIS_YEAR:
      case JobDashboardRange.LAST_24_HOURS:
      case JobDashboardRange.LAST_7_DAYS:
      case JobDashboardRange.LAST_30_DAYS:
      case JobDashboardRange.LAST_90_DAYS:
      case JobDashboardRange.LAST_365_DAYS:
      case JobDashboardRange.ALL_TIME:
        return now;
      case JobDashboardRange.CUSTOM:
        throw new Error('Custom range requires manual input');
      default:
        return now;
    }
  }
}
